<div class="nav-bar">
  <un-nav [menus]="menus" [useFragmentService]="true" [noWrap]="true"></un-nav>
</div>
<main [ngClass]="screenSize.size | async">
  <div class="content">
    @if (tour.description) {
    <section class="description" id="description" #description>
      <h3 class="t-medium" i18n>Description</h3>
      <div class="m-b-32">
        <quill-view [content]="tour.description"></quill-view>
      </div>
      <div class="tour-dates">
        <p class="m-b-16"><strong i18n>Tour dates</strong></p>

        <div class="sessions">
          @for ( session of tour.sessions | slice : 0 : maxSessions; track
          $index) {
          <div class="session">
            <un-tour-session [session]="session"></un-tour-session>
          </div>
          } @if (tour.sessions.length > maxSessions) {
          <a class="c-primary" i18n (click)="maxSessions = maxSessions + 2"
            >See more dates</a
          >}
        </div>
      </div>
    </section>
    } @if (tour.feature) {

    <section class="inclusions" id="inclusions" #inclusions>
      <h3 class="t-medium" i18n>Inclusions</h3>
      @if (tour.feature.description) {
      <div><quill-view [content]="tour.feature.description"></quill-view></div>
      }
      <ul>
        @for ( item of tour.feature.includes; track $index) {
        <li>
          <fa-icon [icon]="faCheck" class="c-success m-r-16"></fa-icon>
          <span>{{ item }}</span>
        </li>
        }
      </ul>
      <ul>
        @for ( item of tour.feature.excludes; track $index) {

        <li>
          <fa-icon [icon]="faTimes" class="c-error m-r-16"></fa-icon>
          <span>{{ item }}</span>
        </li>
        }
      </ul>
    </section>
    } @if (tour.itineraries.length) {

    <section class="itinerary" id="itinerary" #itinerary>
      <h3 class="t-medium" i18n>Itinerary</h3>

      @for (itinerary of tour.itineraries; track $index; let first = $first) {
      <section class="un-card m-t-24">
        <nz-collapse
          [nzBordered]="false"
          nzExpandIconPosition="end"
          [nzAccordion]="true"
        >
          <nz-collapse-panel [nzHeader]="itinerary.heading" [nzActive]="first">
            <p class="t-large m-t-24 m-b-8">
              <strong>{{ itinerary.subHeading }}</strong>
            </p>
            @if (itinerary.description) {
            <div>
              <quill-view [content]="itinerary.description"></quill-view>
            </div>
            }
            <div class="photos">
              @for ( photo of itinerary.photos; track $index) { @if (photo |
              fileUrl : { width: 440, height: 320 } | async; as src) {
              <img
                [ngSrc]="src"
                width="220"
                height="160"
                [alt]="tour.name + ' ' + itinerary.subHeading + ' photos'"
              />}}
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </section>
      }
    </section>
    }
  </div>
  @if ((screenSize.size | async) !== 'small') {
  <un-tour-booking-selection [tour]="tour"></un-tour-booking-selection>
  }
</main>
